import React from 'react'
import { useSelector } from 'react-redux'
import ImageElement from './ImageElement.jsx'

const MobileImageElement = () => {
  const { regionImage, countryImage } = useSelector((state) => state.eyewearResults)

  return (
    <ImageElement image={countryImage || regionImage} />
  )
}

export default MobileImageElement